export default "__VITE_ASSET__2f4b9cc1__"